export enum Sockets {
    closingTime = 1000,
    retry = 3
}